export function hasLowercaseLetters(string: string) {
  for (var i = 0; i < string.length; i++) {
    if (string[i] >= "a" && string[i] <= "z") {
      return true;
    }
  }
  return false;
}
